import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import { environment } from 'src/environments/environment';
import { ViewEncapsulation } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl } from '@angular/forms';


@Component({
  selector: 'app-exchange',
  templateUrl: './exchange.component.html',
  styleUrls: ['./exchange.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExchangeComponent implements OnInit {

  Currencycode: any;
  startDate: any;
  endDate: any;
  exportRate: any;
  ImportRate: any;
  description: string;
  currencys = [];
  currencyId: string;
  currencycode: string;
  cnyname: string;
  ExchangeExport = [] as any;
  public searchText: string;
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  ErrorMsg: string;
  SuccessMsg: string;
  Status: boolean = false;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean = true;
  isShownActive: Boolean = true;
  EditedExchange = [] as any;
  EditedExchangeId: string;
  countryname: string;
  myControl = new FormControl();
  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;

  displayedColumns: string[] = ['sno', 'currencycode', 'dstartdate', 'denddate', 'exportrate', 'importrate', 'status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;


  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.vRead = localStorage.getItem('ExchangeRead');
    this.vWrite = localStorage.getItem('ExchangeWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';
    if (this.vWrite != undefined && this.vWrite != "") {
      if (this.vWrite == "True")
        this.isShownWrite = false;
    }

    this.BindCurrencyDDL();
    this.BindExchangeGrid();
    this.BindExchangeExport();

  }

  Show(event: any) {
    debugger;
    var cny1 = this.currencys;
    let cny: any = event.target.value;

    for (let i = 0; i < cny1.length; i++) {
      if (cny1[i].currencyId == cny) {
        var NAme = cny1[i].countryname;
        this.cnyname = NAme;
      }
    }


  }

  BindCurrencyDDL() {
    var value = this.http.get(environment.apiUrl + 'Exchange/GetCurrencyDDL').toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          debugger;
          this.currencys = data;
          this.currencyId = "0";
          this.countryname = "";
        }
        else {
        };
      });
  }
  SubmitExchange() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vcurrencycode = this.currencyId;
    var vstartdate = this.startDate;
    var vendDate = this.endDate;
    var vExportRate = this.exportRate;
    var vImportRate = this.ImportRate;
    var vdescription = this.description;
    debugger;

    if (vcurrencycode == undefined || vcurrencycode == "" || vcurrencycode == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Currency Code.";
      return false;
    }

    if (vstartdate == undefined || vstartdate == "" || vstartdate == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select start Date.";
      return false;
    }

    if (vendDate == undefined || vendDate == "" || vendDate == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select End Date.";
      return false;
    }

    var vCurrentDate1 = new Date();
    var vFrom1 = new Date(vstartdate);
    var vTo1 = new Date(vendDate);
    // if ((vFrom1) < (vCurrentDate1)) {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Start Date Should Greater then or equal to Current Date.";
    //   return false;
    // }
    // if ((vTo1) < (vCurrentDate1)) {
    //   this.isShownError = false;
    //   this.ErrorMsg = "End Date Should Greater then or equal to Current Date.";
    //   return false;
    // }
    if ((vTo1) < (vFrom1)) {
      this.isShownError = false;
      this.ErrorMsg = "End date should be greater then Start date.";
      return false;
    }

    if (vExportRate == undefined || vExportRate == "" || vExportRate == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Export Rate.";
      return false;
    }

    if (vImportRate == undefined || vImportRate == "" || vImportRate == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Import Rate.";
      return false;
    }

    if (vdescription == undefined || vdescription == "" || vdescription == "0") {
      this.description="";
    }

    let params = new HttpParams();
    debugger;
    params = params.append('dCurrencyId', this.currencyId);
    params = params.append('dStartDate', this.startDate);
    params = params.append('dendDate', this.endDate);
    params = params.append('dexportrate', this.exportRate);
    params = params.append('dimportrate', this.ImportRate);
    params = params.append('ddescription', this.description);
    var value = this.http.get(environment.apiUrl + 'Exchange/InsertExchange', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var currencyd = data;
        this.currencyId = "";
        this.startDate = "";
        this.endDate = "";
        this.exportRate = "";
        this.ImportRate = "";
        this.description = "";
        this.cnyname = "";
        this.SuccessMsg = "Exchange Master Added."
        this.BindExchangeExport();
        this.BindExchangeGrid();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else  if (vErrorMsg1 == "Exist") {
          this.isShownError = false;
          this.ErrorMsg = "Exchange Rate Already Exist For This Date.";
          return false;
        }
        else {
        }
      });
  }

  EditExchange(item: any) {
    this.isShownSaveBtn = true;
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.isShownError = true;
    this.isShownSuccess = true;
    this.EditedExchange = item;
    debugger;
    var vexchangeId = this.EditedExchange.exchangeId;
    var vcurrencyId = this.EditedExchange.currencyId;
    var vexportrate = this.EditedExchange.exportrate;
    var vimportrate = this.EditedExchange.importrate;
    var vstartdate = this.EditedExchange.startdate;
    var venddate = this.EditedExchange.enddate;
    var vdescription = this.EditedExchange.description;

    this.EditedExchangeId = vexchangeId;
    this.currencyId = vcurrencyId;
    this.exportRate = vexportrate;
    this.ImportRate = vimportrate;
    this.description = vdescription;
    var vStatus = this.EditedExchange.status;
    this.startDate = new Date(new Date(vstartdate).setDate(new Date(vstartdate).getDate() + 1)).toISOString().split('T')[0];
    // Another Format
    // var strdate = new Date(vstartdate);
    // var fdate = strdate.setDate(strdate.getDate() +1).toString();
    // debugger;
    // this.startDate = fdate;
    this.endDate = new Date(new Date(venddate).setDate(new Date(venddate).getDate() + 1)).toISOString().split('T')[0];
    if (vStatus == "Active") {
      this.Status = false;
    }
    else {
      this.Status = true;
    }
  }

  ClearExchange() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownActive = true;
    this.isShownUpdateBtn = true;
    this.isShownSaveBtn = false;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.currencyId = "";
    this.exportRate = "";
    this.ImportRate = "";
    this.startDate = "";
    this.endDate = "";
    this.description = "";
    this.cnyname = "";
    this.Status = false;
  }

  UpdateExchange() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    var vcurrencycode = this.currencyId;
    var vstartdate = this.startDate;
    var vendDate = this.endDate;
    var vExportRate = this.exportRate;
    var vImportRate = this.ImportRate;
    var vdescription = this.description;
    debugger;

    if (vcurrencycode == undefined || vcurrencycode == "" || vcurrencycode == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Currency Code.";
      return false;
    }

    if (vstartdate == undefined || vstartdate == "" || vstartdate == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select start Date.";
      return false;
    }

    if (vendDate == undefined || vendDate == "" || vendDate == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select End Date.";
      return false;
    }

    if (vExportRate == undefined || vExportRate == "" || vExportRate == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Export Rate.";
      return false;
    }

    if (vImportRate == undefined || vImportRate == "" || vImportRate == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Import Rate.";
      return false;
    }

    if (vdescription == undefined || vdescription == "" || vdescription == "0") {
      this.description = "";
    }

    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";

    let params = new HttpParams();
    debugger;
    params = params.append('iCurrencyId', this.currencyId);
    params = params.append('iStartDate', this.startDate);
    params = params.append('iendDate', this.endDate);
    params = params.append('iexportrate', this.exportRate);
    params = params.append('iimportrate', this.ImportRate);
    params = params.append('idescription', this.description);
    params = params.append('iExchangeId', this.EditedExchangeId);
    params = params.append('istatus', vStatus);
    debugger;
    var value = this.http.get(environment.apiUrl + 'Exchange/UpdateExchange', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var currencyd = data;
        this.currencyId = "";
        this.startDate = "";
        this.endDate = "";
        this.exportRate = "";
        this.ImportRate = "";
        this.description = "";
        this.cnyname = "";
        this.isShownSaveBtn = false;
        this.isShownActive = true;
        this.isShownUpdateBtn = true;
        this.SuccessMsg = "Exchange Master Updated."
        this.BindExchangeExport();
        this.BindExchangeGrid();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Update Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });

  }


  BindExchangeGrid() {
    var value = this.http.get(environment.apiUrl + 'Exchange/GetExchangeForGrid').toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      });
  }
  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  BindExchangeExport() {
    var value = this.http.get(environment.apiUrl + 'Exchange/GetExchangeForExport').toPromise().then(
      (data: any) => {
        debugger;
        this.ExchangeExport = data;
      });
  }

  exportexcel(): void {
    debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.ExchangeExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'Exchange');

    /* save to file */
    XLSX.writeFile(wb, "Exchange.xlsx");

  }

}
